import { EditingUsers } from './types'

export function isEditingUser(editingUsers: EditingUsers, userId?: string): boolean {
  if (!userId) {
    return false
  }

  return !!editingUsers[userId]
}
